/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForActivityExecutor extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForActivityExecutor");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForActivityExecutor.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForActivityExecutor>): BackgroundJobPayloadForActivityExecutor {
        let obj = Object.assign(new BackgroundJobPayloadForActivityExecutor(), model);
        BackgroundJobPayloadForActivityExecutor.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForActivityExecutor>): BackgroundJobPayloadForActivityExecutor {
        if (!model) return null;
        return BackgroundJobPayloadForActivityExecutor.newInstance(<BackgroundJobPayloadForActivityExecutor> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForActivityExecutor) {
        if (!obj) return;

        models.BackgroundJobPayloadForActivityExecutor.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForActivityExecutor): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForActivityExecutor.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Type of activity executor action
     */
    activity_type: models.ActivityExecutorType;

    /**
     * alert data in json encoded text
     */
    alert_data: string;

}
